import { render } from "./BoardNoticeCreatePage.vue?vue&type=template&id=3bb372da&lang=true"
import script from "./BoardNoticeCreatePage.vue?vue&type=script&lang=js"
export * from "./BoardNoticeCreatePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__